import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

function Connexion() {
    const [user, setUser] = useState({
        mail: '',
        mdp: ''
    });
    const navigate = useNavigate();
    const [message, setMessage] = useState('');
    const [emailError, setEmailError] = useState(false);

    useEffect(() => {
        // Fonction pour valider l'adresse e-mail
        const validateEmail = (email) => {
            // Expression régulière pour vérifier la structure de l'adresse e-mail
            const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return regex.test(email);
        };

        // Mettez à jour l'état de l'erreur d'e-mail
        setEmailError(!validateEmail(user.mail));
    }, [user.mail]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Vérifiez si l'adresse e-mail est valide avant d'envoyer la requête
        if (emailError) {
            setMessage("Adresse e-mail invalide");
            return;
        }

        try {
            const response = await fetch('https://api-test-vercel-3z97vnle5-laurents-projects-932866c2.vercel.app/user/connect-user', {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(user)
            });

            if (response.status === 200) {
                // setMessage("Connexion de l'utilisateur réussie")
                navigate("/");
            } else {
                setMessage("email et/ou mot de passe incorrect(s)");
            }
        } catch (error) {
            setMessage("Erreur lors de la connexion");
        }
    };

    const handleChange = (e) => {
        e.preventDefault();
        const { name, value } = e.target;
        setUser({ ...user, [name]: value });
    };

    return (
        <section className="container_news log">
            <article className="container_connexion">
                <form onSubmit={handleSubmit} className="form_connexion">
                    <h2>Connexion</h2>
                    <div className={`form-control champ ${emailError ? 'error' : ''}`}>
                        <input
                            type="mail"
                            name="mail"
                            onChange={handleChange}
                            required
                        />
                        <label>
                            <span style={{ transitionDelay: '0ms' }}>E</span>
                            <span style={{ transitionDelay: '50ms' }}>-</span>
                            <span style={{ transitionDelay: '100ms' }}>m</span>
                            <span style={{ transitionDelay: '150ms' }}>a</span>
                            <span style={{ transitionDelay: '200ms' }}>i</span>
                            <span style={{ transitionDelay: '250ms' }}>l</span>
                        </label>
                    </div>
                    <div className="form-control champ">
                        <input
                            type="password"
                            name="mdp"
                            onChange={handleChange}
                            required
                        />
                        <label>
                            <span style={{ transitionDelay: '0ms' }}>M</span>
                            <span style={{ transitionDelay: '50ms' }}>o</span>
                            <span style={{ transitionDelay: '100ms' }}>t</span>
                            <span style={{ transitionDelay: '150ms' }}></span>
                            <span style={{ transitionDelay: '200ms' }}>d</span>
                            <span style={{ transitionDelay: '250ms' }}>e</span>
                            <span style={{ transitionDelay: '300ms' }}></span>
                            <span style={{ transitionDelay: '350ms' }}>p</span>
                            <span style={{ transitionDelay: '400ms' }}>a</span>
                            <span style={{ transitionDelay: '450ms' }}>s</span>
                            <span style={{ transitionDelay: '500ms' }}>s</span>
                            <span style={{ transitionDelay: '550ms' }}>e</span>
                        </label>
                        <a href="" className="btn-inscription">mot de passe oublié ?</a>
                    </div>
                    <p className="message">{message}</p>
                    <button className="button">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12h15m0 0l-6.75-6.75M19.5 12l-6.75 6.75"></path>
                        </svg>
                        <div className="text">
                            Se connecter
                        </div>
                    </button>
                </form>
                <a href="/inscription" className="btn-inscription">Pas de compte ?</a>
            </article>
        </section>
    );
}

export default Connexion;
